<div class="card flex-1 d-flex fd-col">


  <ng-container *ngFor="let display of displays; trackBy: trackDisplay; let last=last">

    <ng-container *ngIf="display.labelMode === 'split'">
      <span class="property-name">{{ display.property?.displayName || '?' }}</span>
      <mat-divider></mat-divider>
    </ng-container>
    <div class="paragraph-value-box" [class.paragraph-floating-box]="display.labelMode === 'floating'">
      <span *ngIf="display.labelMode === 'floating'" class="property-floating-label">
        {{ display.property?.displayName || '?' }}
      </span>
      <suvo-bi-property [property]="display.property" [item]="item" [control]="display.control"
        [editItemMode]="editItemMode">
      </suvo-bi-property>
    </div>
    <mat-divider *ngIf="!last"></mat-divider>

  </ng-container>

</div>